<template>
  <b-modal
    ref="modal"
    id="view-counselor-modal"
    class="large-modal"
    size="xl"
  >
    <template #modal-header>
      <div class="upper">
        <h3>View Message</h3>
      </div>      
      <button
        class="close"
        @click="hide()"
      > 
        ×
      </button>
    </template>

    <div class="row">
      <div class="col-12">

        <Loader v-if="!messages" style="width: 100%;" />

        <p v-else-if="messages.length === 0">There are no messages yet.</p>
        <message-thread v-else :messages="messages" :reply="reply" />
      </div>
    </div>

    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Dismiss
      </button>
    </template>

  </b-modal>
</template>

<script>
import MessageThread from '@/components/MessageThread.vue';
import Loader from '@/components/Loader';

export default {
  name: 'ViewMessagesModal',
  components: {
    MessageThread,
    Loader,
  },
  data() {
    return {
      thread: null,
    };
  },
  props: {
    reply: {
      type: Function,
    },
    messages: {
      type: Array,
    },
  },
  methods: {
    show(thread) {
      this.thread = thread;

      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
